import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Devices = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 16 16"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <defs>
          <clipPath id="devices__a">
            <rect
              x="0"
              y="0"
              width="16"
              height="16"
              rx="0"
            />
          </clipPath>
        </defs>
        <g clipPath="url(#devices__a)">
          <path
            d="M14,4.5L13,4.5L13,4C13,3.602175,12.84195,3.22064495,12.56065,2.93934011C12.27935,2.65803504,11.8978,2.5,11.5,2.5L2.5,2.5C2.102175,2.5,1.72064495,2.65803504,1.43934,2.93934011C1.15803504,3.22064495,1,3.602175,1,4L1,10C1,10.397800400000001,1.15803504,10.7793503,1.43934,11.0606499C1.72064495,11.3419504,2.102175,11.5,2.5,11.5L9.5,11.5L9.5,12C9.5,12.3978004,9.6580496,12.77935,9.9393501,13.06065C10.2206497,13.34195,10.6021996,13.5,11,13.5L14,13.5C14.3978,13.5,14.77935,13.34195,15.06065,13.06065C15.34195,12.77935,15.5,12.3978004,15.5,12L15.5,6C15.5,5.6022,15.34195,5.2206502,15.06065,4.9393401C14.77935,4.658034799999999,14.3978,4.5,14,4.5ZM14.5,12C14.5,12.1325998,14.4473,12.2598,14.35355,12.35355C14.2598,12.4473,14.1326,12.5,14,12.5L11,12.5C10.8674002,12.5,10.7402,12.4473,10.64645,12.35355C10.5527,12.2598,10.5,12.1325998,10.5,12L10.5,6C10.5,5.8674002000000005,10.5527,5.7402,10.64645,5.64645C10.7402,5.5527,10.8674002,5.5,11,5.5L14,5.5C14.1326,5.5,14.2598,5.5527,14.35355,5.64645C14.4473,5.7402,14.5,5.8674002000000005,14.5,6L14.5,12ZM8.5,13C8.5,13.1326,8.4473,13.2598,8.35355,13.35355C8.2598,13.4473,8.132599800000001,13.5,8,13.5L5.5,13.5C5.3674002,13.5,5.2402,13.4473,5.14645,13.35355C5.0527,13.2598,5,13.1326,5,13C5,12.8674,5.0527,12.7402,5.14645,12.64645C5.2402,12.5527,5.3674002,12.5,5.5,12.5L8,12.5C8.132599800000001,12.5,8.2598,12.5527,8.35355,12.64645C8.4473,12.7402,8.5,12.8674,8.5,13ZM13.5,7C13.5,7.1325998,13.4473,7.2598,13.35355,7.35355C13.2598,7.4473,13.1326,7.5,13,7.5L12,7.5C11.8674,7.5,11.7402,7.4473,11.64645,7.35355C11.5527,7.2598,11.5,7.1325998,11.5,7C11.5,6.8674002,11.5527,6.7402,11.64645,6.64645C11.7402,6.5527,11.8674,6.5,12,6.5L13,6.5C13.1326,6.5,13.2598,6.5527,13.35355,6.64645C13.4473,6.7402,13.5,6.8674002,13.5,7Z"
            data-follow-fill="#455766"
            fill={_fill}
          />
        </g>
      </svg>
    )
  }
)
